module.exports = __webpack_public_path__ + "img/right.928e25eb.svg";